import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import dayjs from "dayjs";
import { EditButton } from "components/ui/atoms/Button";
import { ViewCheckbox } from "components/ui/atoms/Checkbox";
import {
  LabelValueForTags,
  LabelValueForText,
} from "components/ui/atoms/LabelValue";
import SectionGrid from "components/ui/atoms/SectionGrid";
import { ColorTag, SourcingStatusTag } from "components/ui/atoms/Tag";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";
import { useResetDealFlowCompanyState } from "models/companies/apiCompany";
import { useSourcing } from "models/sourcings/apiSourcing";
import { useModal } from "@ebay/nice-modal-react";

const SourcingInfo = ({ sourcingId }) => {
  const sourcingModal = useModal("SourcingDrawer");
  const { data: sourcing, isLoading, isError } = useSourcing(sourcingId);
  const resetDealFlowCompanyState = useResetDealFlowCompanyState();

  if (isLoading) return <Skeleton variant="rectangular" height={200} />;
  if (isError) return <>Error</>;

  return (
    <>
      <Grid container spacing={1}>
        <EditButton
          onClick={() =>
            sourcingModal
              .show({ id: sourcing.id, formType: "update" })
              .then(() => resetDealFlowCompanyState(sourcing.company))
          }
        />
        <SectionGrid title="Information" size={{ xs: 12, md: 6 }}>
          <LabelValueForText
            label="Owner"
            value={sourcing.sourcing_owner_detail?.fullname}
            isMissing={
              sourcing.sourcing_owner_detail?.fullname.trim() === "" ||
              sourcing.sourcing_owner_detail === null
            }
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Status"
            value={<SourcingStatusTag status={sourcing.status} />}
            isMissing={
              sourcing.status.trim() === "" || sourcing.status === null
            }
            sx={{ mb: 0.5 }}
          />
          {sourcing.status === "REMINDER" && (
            <LabelValueForText
              label="Reminder Date"
              value={dayjs(sourcing.reminder_date).format("DD/MM/YYYY")}
              isMissing={sourcing.reminder_date === null}
              sx={{ mb: 0.5 }}
            />
          )}
          <LabelValueForText
            label="To be checked"
            value={<ViewCheckbox value={sourcing.to_be_checked} />}
            isMissing={sourcing.to_be_checked === null}
            sx={{ mb: 0.5 }}
          />
        </SectionGrid>
        <SectionGrid title="Context" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={
              sourcing.context.trim() === "" || sourcing.context === null
            }
          >
            {sourcing.context}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Actions taken" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={
              sourcing.actions_taken === "" || sourcing.actions_taken === null
            }
          >
            {sourcing.actions_taken}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Reason to close" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={
              sourcing.reason_to_close.trim() === "" ||
              sourcing.reason_to_close === null
            }
          >
            {sourcing.reason_to_close}
          </TypographyWithMiss>
          {sourcing.reason_to_close_tag.length > 0 && (
            <LabelValueForTags
              Tags={sourcing.reason_to_close_tag.map((tagId) => (
                <ColorTag key={tagId} tagId={tagId} />
              ))}
              sx={{ py: 1, mb: 0.5 }}
            />
          )}
        </SectionGrid>
      </Grid>
    </>
  );
};

export default SourcingInfo;
